var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStopShape = function SvgStopShape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 2.28868C8.8094 2.11004 9.1906 2.11004 9.5 2.28868L15.4282 5.71132C15.7376 5.88996 15.9282 6.22008 15.9282 6.57735V13.4226C15.9282 13.7799 15.7376 14.11 15.4282 14.2887L9.5 17.7113C9.1906 17.89 8.8094 17.89 8.5 17.7113L2.5718 14.2887C2.2624 14.11 2.0718 13.7799 2.0718 13.4226V6.57735C2.0718 6.22008 2.2624 5.88996 2.5718 5.71132L8.5 2.28868Z",
    fill: "#0f625f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.42285C8.6188 1.06559 9.3812 1.06559 10 1.42285L15.9277 4.8457C16.5465 5.20294 16.9277 5.8627 16.9277 6.57715V13.4229C16.9277 14.1373 16.5465 14.7971 15.9277 15.1543L10 18.5771C9.3812 18.9344 8.6188 18.9344 8 18.5771L2.07227 15.1543C1.45352 14.7971 1.07234 14.1373 1.07227 13.4229V6.57715C1.07234 5.86269 1.45352 5.20293 2.07227 4.8457L8 1.42285Z",
    stroke: "#55B8B3",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })));
};
export { SvgStopShape as ReactComponent };
export default __webpack_public_path__ + "assets/3cb5907e.svg";